import { useRouter } from "next/router";

import { useEffect, useState } from "react";

import { captureException } from "@sentry/nextjs";

import { PURPOSES_TYPES } from "enums/purposesTypes";

import { API_ROUTES } from "config/routes";

import { isRedeemed } from "utils/redeem";

import { RedeemProposalStatus } from "services/redeem/RedeemProposalResult";

import fetcher from "lib/fetchJson";

const useRedeemInfo = (
  contractAddress: string,
  token: number,
  isOwner: boolean,
): {
  redeemInfo: RedeemProposalStatus[] | null;
  isLoading: boolean;
  isPhysicalRedeemed: boolean;
  isDecentralandRedeemed: boolean;
} => {
  const router = useRouter();
  const [redeemInfo, setRedeemInfo] = useState<RedeemProposalStatus[] | null>(
    null,
  );
  const [isLoading, setLoading] = useState<boolean>(true);
  const [isPhysicalRedeemed, setPhysicalRedeemed] = useState<boolean>(true);
  const [isDecentralandRedeemed, setDecentralandRedeemed] =
    useState<boolean>(true);

  useEffect(() => {
    if (!isOwner) {
      setLoading(false);
      return;
    }
    async function getRedeemInfo() {
      setLoading(true);
      try {
        const { data } = await fetcher<{ data: RedeemProposalStatus[] }>(
          `${API_ROUTES.REDEEM_INFO}/${contractAddress}/${token}`,
        );
        setRedeemInfo(data);

        const isPhysicalRedeemed =
          isRedeemed(data, PURPOSES_TYPES.PHYSICAL) ||
          isRedeemed(data, PURPOSES_TYPES.PHYSICAL_TO_NFT);
        setPhysicalRedeemed(isPhysicalRedeemed);
        setDecentralandRedeemed(isRedeemed(data, PURPOSES_TYPES.DECENTRALAND));
      } catch (e) {
        captureException(e);
      }
      setLoading(false);
    }

    getRedeemInfo();
  }, [contractAddress, token, isOwner, router.asPath]);
  return {
    redeemInfo,
    isLoading,
    isPhysicalRedeemed,
    isDecentralandRedeemed,
  };
};

export default useRedeemInfo;
